
import React, { useState } from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { useDebouncedCallback } from 'use-debounce';
import { supabase } from '@/integrations/supabase/client';

interface HebrewTitleInputProps {
  value: string;
  onChange: (value: string, translatedValue: string) => void;
}

export const HebrewTitleInput = ({ value, onChange }: HebrewTitleInputProps) => {
  const [isTranslating, setIsTranslating] = useState(false);

  const debouncedTranslate = useDebouncedCallback(async (hebrewText: string) => {
    if (hebrewText.trim()) {
      setIsTranslating(true);
      try {
        const { data, error } = await supabase.functions.invoke('translate', {
          body: { text: hebrewText }
        });

        if (error) throw error;
        if (data?.translation) {
          onChange(hebrewText, data.translation);
        }
      } catch (error) {
        console.error('Translation error:', error);
      } finally {
        setIsTranslating(false);
      }
    }
  }, 1000);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const hebrewText = e.target.value;
    onChange(hebrewText, '');
    debouncedTranslate(hebrewText);
  };

  return (
    <div>
      <Label htmlFor="hebrewTitle" dir="rtl" className="block text-right w-full">כותרת משימה בעברית</Label>
      <Input
        id="hebrewTitle"
        dir="rtl"
        value={value}
        onChange={handleChange}
        className="mt-1 text-right"
        placeholder="הכנס כותרת משימה"
      />
    </div>
  );
};
